import { type UseQueryResult, useQuery } from 'react-query';
import {
  NoticeService,
  Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto,
} from '../../services/wealthlane-award-services';

const useGetGrantAcceptanceTemplateList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  // eslint-disable-next-line camelcase

  Wealthlane_AwardService_Dtos_Notices_NoticeResponseDto[] | undefined,
  unknown
> => {
  //   const { filter, sorting, skipCount, maxResultCount } = tableInfo;
  const grantAcceptanceTemplateList = useQuery(['getGrantAcceptanceTemplateList'], async () => {
    return await handleRequest(NoticeService.getApiAwardApiNotices());
  });

  return grantAcceptanceTemplateList;
};

export default useGetGrantAcceptanceTemplateList;
